<template>
  <div class="tutorial-container">
    <div class="back" v-on:click="goBack">
      Back to Dashboard
    </div>

    <div class="tutorial-content-container">
      <VueFaqAccordion
        :activeColor="tutorialProps.activeColor"
        :borderColor="tutorialProps.borderColor"
        :items="tutorials"
        class="tutorial-wrapper"
      />
    </div>
  </div>
</template>

<script>
import '../styles/base.css'
import VueFaqAccordion from 'vue-faq-accordion'

export default {
  name: 'Tutorials',

  components: {
    VueFaqAccordion
  },

  data () {
    return {
      tutorials: [
        {
          title: 'How do I build a slide?',
          value: 'Slides can be created by using your own custom design or via one of our 400,000+ slide templates.<br><h3>Upload Custom Design</h3><ol><li>Select "Slide Builder" on the navigation bar:<img src="https://powerslide-images.s3.amazonaws.com/1-slide-builder.png" style="display: block; padding: 1em;"/></li><li>Select "Upload Your Slide" at the bottom of the slide list <img src="https://powerslide-images.s3.amazonaws.com/2-upload-your-slide.png" style="display: block; padding: 1em;"/></li><li>Drag and drop your image within the upload dialog or click within the upload dialog to select an image from your device <img src="https://powerslide-images.s3.amazonaws.com/3-upload.png" style="display: block; padding: 1em;"/></li></ol><h3>Create a Template Based Slide</h3><ol><li>Select "Slide Builder" on the navigation bar:<img src="https://powerslide-images.s3.amazonaws.com/1-slide-builder.png" style="display: block; padding: 1em;"/></li><li>Select "Create a Template Based Slide" at the bottom of the slide list<img src="https://powerslide-images.s3.amazonaws.com/2-template-based-slide.png" style="display: block; padding: 1em;"/></li><li>Select a template that you would like to edit or search for a template via the search bar<img src="https://powerslide-images.s3.amazonaws.com/3-select-template.png" style="display: block; padding: 1em;"/></li><li>Make changes to your template in the template editor<img src="https://powerslide-images.s3.amazonaws.com/4-edit-template.png" style="display: block; padding: 1em;"/></li><li>Select "save" on the top right of the editor. <img src="https://powerslide-images.s3.amazonaws.com/5-save.png" style="display: block; padding: 1em;"/></li></ol>',
          category: 'How to use Powerslide'
        },
        {
          title: 'How do I build a slideshow?',
          value: 'In order to create a slideshow, you must first create a slide. If you do not have a slide, please see the "How do I build a slide?" tutorial above.<br><h3>To Create a Slideshow</h3><ol><li>Select "Slideshows" on the navigation bar:<img src="https://powerslide-images.s3.amazonaws.com/1-slideshows.png" style="display: block; padding: 1em;"/></li><li>Select "Create a Slideshow" at the bottom of the slideshow list<img src="https://powerslide-images.s3.amazonaws.com/2-create-slideshow.png" style="display: block; padding: 1em;"/></li><li>Enter a name for your slideshow in the "Name" field at the top of the page (not required)</li><li>Select "Add and Remove Slides"<img src="https://powerslide-images.s3.amazonaws.com/3-add-remove-slides.png" style="display: block; padding: 1em;"/></li><li>Select the slides that you would like to appear in your slideshow. Slides that have been selected will be highlighted with a green border. <img src="https://powerslide-images.s3.amazonaws.com/4-select-slides.png" style="display: block; padding: 1em;"/></li><li>Select "Confirm Slide Selection" button at the bottom of the page to save your new slideshow.</li></ol>',
          category: 'How to use Powerslide'
        },
        {
          title: 'How do I delete a slide?',
          value: '<ol><li>Select "Slide Builder" on the navigation bar:<img src="https://powerslide-images.s3.amazonaws.com/1-slide-builder.png" style="display: block; padding: 1em;"/></li><li>Select the slide that you would like to delete.</li><li>Select "Delete Slide" button</li><li>If you are sure that you want to delete this slide, select the "Confirm Delete" button</li></ol>',
          category: 'How to use Powerslide'
        },
        {
          title: 'How do I delete a slideshow?',
          value: '<ol><li>Select "Slideshows" on the navigation bar:<img src="https://powerslide-images.s3.amazonaws.com/1-slideshows.png" style="display: block; padding: 1em;"/></li><li>Select the slideshow that you would like to delete</li><li>Select "Delete Slideshow" button</li><li>If you are sure that you want to delete this slideshow, select the "Confirm Delete" button</li></ol>',
          category: 'How to use Powerslide'
        },
        {
          title: 'How do I add additional users?',
          value: '<ol><li>Select "Users" on the navigation bar:<img src="https://powerslide-images.s3.amazonaws.com/1-users.png" style="display: block; padding: 1em;"/></li><li>Select "Invite User" button at the top right of the screen:<img src="https://powerslide-images.s3.amazonaws.com/2-invite-user.png" style="display: block; padding: 1em;"/></li><li>Fill out the info in the new user dialog box:<img src="https://powerslide-images.s3.amazonaws.com/3-send-invite.png" style="display: block; padding: 1em;"/></li><li>Select "Send Invite" button</li></ol>',
          category: 'How to use Powerslide'
        }
      ],
      tutorialProps: {
        activeColor: '#049292',
        borderColor: '#cccccc'
      }
    }
  },

  methods: {
    goBack: function () {
      this.$parent.setSelectedPane('slide-builder')
    }
  }
}
</script>

<style scoped>
  .faq {
    padding: 0 !important;
  }

  .tutorial-content {
    margin: 0 auto;
    min-height: calc(100vh - 6em);
    padding-bottom: 6em;
    width: 100%;
  }

  .tutorial-content-container {
    margin-bottom: 4em;
    text-align: center;
  }

  .tutorial-wrapper {
    margin: 0 auto !important;
    width: 100% !important;
  }

  td {
    padding-right: 3em;
    font-weight: 500;
  }
</style>
